<template>
  <v-layout column class="resource-panel-content1">
    <v-layout class="pt-2 shrink">
      <v-btn text small @click="$emit('back')">
        <v-icon small>keyboard_arrow_left</v-icon> BACK
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn text right @click="$emit('openFullModal', resource.id)">open resource</v-btn>
    </v-layout>
    <div class="pa-2">
      <resource-card
        variant="full"
        :blockData="{ resource: resource }"
        blockType="block"
        @click="userCanEdit ? addResourceToPage() : null"
      >
        <template v-if="userCanEdit" v-slot="props">
          <v-tooltip right open-delay="200" transition="fade" v-if="props.hover">
            <template v-slot:activator="{ on }">
              <v-fade-transition>
                <v-btn
                  v-if="props.hover"
                  outlined
                  icon
                  x-small
                  style="position: absolute; left: -8px; background: white; z-index: 1;"
                  v-on="on"
                  @click.stop.prevent="addResourceToPage()"
                >
                  <v-icon small>add</v-icon>
                </v-btn>
              </v-fade-transition>
              <!-- <v-btn
                outlined
                icon
                x-small
                style="position: absolute; right: +8px; background: lightred;"
                v-on="on"
                @click.stop="deleteResourceNoteBlockHandler(noteBlock.id)"
              >
                <v-icon small>delete</v-icon>
              </v-btn> -->
            </template>
            <span>Add resource to notebook</span>
          </v-tooltip>
        </template>
      </resource-card>
    </div>
    <v-divider></v-divider>
    <v-card flat style="overflow-y: auto;" id="resource-excerpts">
      <div class="pa-2" v-for="noteBlock in sortedNoteBlocks" :key="noteBlock.id">
        <resource-card
          :id="`rp-excerpt-${noteBlock.id}`"
          :blockData="{ resource: resource, excerpts: [noteBlock] }"
          blockType="excerpt"
          :color="focus == noteBlock.id ? 'red lighten-4' : 'white'"
          @click="userCanEdit ? addResourceToPage(noteBlock.id) : null"
        >
          <template v-if="userCanEdit" v-slot="props">
            <v-tooltip right open-delay="200" transition="fade" v-if="props.hover">
              <template v-slot:activator="{ on }">
                <v-fade-transition>
                  <v-btn
                    outlined
                    icon
                    x-small
                    style="position: absolute; left: -8px; background: white;"
                    v-on="on"
                    @click.stop="addResourceToPage(noteBlock.id)"
                  >
                    <v-icon small>add</v-icon>
                  </v-btn>
                </v-fade-transition>
                <!-- <v-btn
                  outlined
                  icon
                  x-small
                  style="position: absolute; left: -8px; top: 35px; background: red;"
                  v-on="on"
                  @click.stop="deleteResourceNoteBlockHandler(noteBlock.id)"
                >
                  <v-icon small>delete</v-icon>
                </v-btn> -->
              </template>
              <span>Add excerpt to notebook</span>
            </v-tooltip>
          </template>
        </resource-card>
      </div>
    </v-card>
  </v-layout>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import ResourceCard from '@/components/Resources/ResourceCard';
export default {
  name: 'App',
  props: ['resource', 'focus'],
  components: { ResourceCard },
  computed: {
    ...mapState('views/context', ['selectedPageId']),
    ...mapGetters('context', ['userCanEdit']),
    sortedNoteBlocks() {
      let result;
      try {
        const resourceType = this.resource.resourceData.type;
        if (resourceType == 'webpage' || resourceType == 'pdf') {
          //  TRYING TO SORT FIRST BY POSITION, THEN BY DATE IF NO POSITION
          let positionExcerpts = [];
          let dateExcerpts = [];
          Object.values(this.resource.noteBlocks).forEach(n => {
            if (n.toDelete || n.type == 'note') {
              return;
            } else {
              if (
                n.content.widgetData.order ||
                (n.content.widgetData.positions && n.content.widgetData.positions[0])
              ) {
                positionExcerpts.push(n);
              } else {
                dateExcerpts.push(n);
              }
            }
          });
          console.log(positionExcerpts, dateExcerpts);
          positionExcerpts = positionExcerpts.sort((a, b) => {
            if (resourceType == 'webpage') {
              return a.content.widgetData.order < b.content.widgetData.order ? -1 : 1;
            } else if (resourceType == 'pdf') {
              return a.content.widgetData.pages[0] + a.content.widgetData.positions[0].y >
                b.content.widgetData.pages[0] + b.content.widgetData.positions[0].y
                ? 1
                : -1;
            }
          });
          dateExcerpts = dateExcerpts.sort((a, b) => {
            const aDate =
              typeof a.createdOn.toDate == 'function' ? a.createdOn.toDate() : a.createdOn;
            const bDate =
              typeof b.createdOn.toDate == 'function' ? b.createdOn.toDate() : b.createdOn;
            return aDate < bDate ? -1 : 1;
          });

          //  Now merge the date excerpts into the position excerpts by date
          let excerpts = [];
          positionExcerpts.forEach(e => {
            //  Do this because when it's first added it's not a datetime object

            const dateExcerpt = dateExcerpts[0];
            if (!dateExcerpt) {
              excerpts.push(e);
              return;
            }
            const dateExDate =
              typeof dateExcerpt.createdOn.toDate == 'function'
                ? dateExcerpt.createdOn.toDate()
                : e.createdOn;
            const exDate =
              typeof e.createdOn.toDate == 'function' ? e.createdOn.toDate() : e.createdOn;
            if (exDate > dateExDate) {
              // we shoudl insert the dateEx before the excerpt
              excerpts.push(dateExcerpt);
              excerpts.push(e);
              //  and remove that excpert from date excerpts
              dateExcerpts = dateExcerpts.slice(1);
            } else {
              excerpts.push(e);
            }
          });
          //  check if there are any left of date excerpts;
          if (dateExcerpts.length) {
            excerpts = excerpts.concat(dateExcerpts);
          }
          result = excerpts;
        }
        // else if (resourceType == 'pdf') {
        //   result = Object.values(this.resource.noteBlocks)
        //     .filter(e => !e.toDelete)
        //     .sort((a, b) => {
        //       if (a.content.widgetData.positions) {
        //         return a.content.widgetData.pages[0] + a.content.widgetData.positions[0].y >
        //           b.content.widgetData.pages[0] + b.content.widgetData.positions[0].y
        //           ? 1
        //           : -1;
        //       } else {
        //         const aDate =
        //           typeof a.createdOn.toDate == 'function' ? a.createdOn.toDate() : a.createdOn;
        //         const bDate =
        //           typeof b.createdOn.toDate == 'function' ? b.createdOn.toDate() : b.createdOn;
        //         return aDate < bDate ? -1 : 1;
        //       }
        //     });
        // }
      } catch (e) {
        console.log(e);
        result = [];
      }
      return result;
    }
  },
  mounted() {
    console.log('mounted');
    if (this.focus) {
      console.log(this.focus);
      const focusId = `#rp-excerpt-${this.focus}`;
      this.$vuetify.goTo(focusId, { container: '#resource-excerpts' });
    }
  },
  methods: {
    ...mapActions('pages', ['addNoteBlock']),
    ...mapActions('resources', ['deleteResourceNoteBlock']),
    addResourceToPage(excerptId) {
      this.$emit('addResourceToPage', { excerptId, resource: this.resource });
      // this.addNoteBlock({
      //   pageId: this.selectedPageId,
      //   html: false,
      //   widgetInfo: {
      //     widgetType: 'resource',
      //     widgetData: {
      //       resourceId: this.resource.id,
      //       resourceVersion: this.resource.version,
      //       resourceNoteIds: noteId ? [noteId] : []
      //     }
      //   }
      // });
    },
    deleteResourceNoteBlockHandler(noteId) {
      // console.log('delete resource handler');
      this.deleteResourceNoteBlock({
        resourceId: this.resource.id,
        noteBlockId: noteId
      });
    }
  }
};
</script>

<style>
.site-info div {
  line-height: 1.3 !important;
}
</style>
